module.exports = __webpack_public_path__ + "img/defaultUserProfile.d40830f2.jpg";